import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { BASE_URL } from "../../../constant";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import KendoLoadingPanel from "../../KendoLoadingPanel";
import { ToastContainer, toast } from "react-toastify";
import { formatDate } from "@telerik/kendo-intl";
import Scheduler from "./Scheduler";
import AppContext from "../../../AppContext";
import { useTranslation } from "react-i18next";

const AssetScheduleList = () => {
  const { t } = useTranslation();
  const defaultViewMode = [
    { id: "grid", name: t("masters.headerTexts.grid"), current: true },
    {
      id: "scheduler",
      name: t("masters.headerTexts.scheduler"),
      current: false,
    },
  ];
  const scheduleObj = useRef();
  const { authCtx, darkMode } = useContext(AppContext);
  const [data, setData] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [scheduleData, setScheduleData] = useState([]);
  const [viewModes, setViewModes] = useState(defaultViewMode);

  // const boolColumn = (props) => {
  //   return (
  //     <div>
  //       {props.dataItem.active === true ? (
  //         <div className=" text-green-600 py-2">Active</div>
  //       ) : (
  //         <div className=" text-orange-600 py-2">Inactive</div>
  //       )}
  //     </div>
  //   );
  // };
  const loadData = async () => {
    try {
      setLoading(true);

      const companyId =
        // authCtx.profile.role !== 100
        //   ?
        authCtx.profile?.companyId;
      // : superAdminCompany.id;
      const res = await axios.get(
        `${BASE_URL}/api/AssetScheduler?companyId=${companyId}&userRole=${authCtx.profile.role}`
      );
      setData(res.data);
      setFilteredData(res.data);
      const assetIds = res.data
        .map((x) => x.scheduleData.map((y) => y.assetId))
        .flat();
      const assetColorCompination = assetIds.map((x, index) => {
        let hue;
        if (index * (360 / assetIds.length) < 200) {
          hue = index * (360 / assetIds.length);
        } else {
          hue = (index * (360 / assetIds.length) + 60) % 360;
        }

        // Convert HSL color to RGB
        const color = `hsl(${hue}, 100%, 50%)`;
        return {
          assetId: x,
          color,
        };
      });
      setScheduleData(
        res.data
          .map((x) =>
            x.scheduleData.map((y) => {
              return {
                ...y,
                scheduleStart: x.startDate,
                scheduleEnd: x.endDate,
                scheduleName: x.name,
                scheduleId: x.id,
                schedules: y.schedules.map((z, i) => ({
                  Id: `${y.assetId}-${i}`,
                  StartTime: new Date(z.startTime),
                  EndTime: new Date(z.endTime),
                  assetId: y.assetId,
                  assetName: y.assetName,
                  assetColor: assetColorCompination.find(
                    (s) => s.assetId === y.assetId
                  ).color,
                  scheduleId: x.id,
                  scheduleName: x.name,
                })),
              };
            })
          )
          .flat()
      );
      setLoading(false);
    } catch (err) {
      if (err.response?.status === 400) toast.error(err.response.data);
      // else toast.error("An error occured");
    }
  };
  const onCloseClick = (e) => {
    navigate(`/settings`);
  };

  const onSearch = (e) => {
    setFilteredData(
      data.filter((s) =>
        s.name.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  const onEditClick = (e) => {
    navigate(`/assetScheduler/${e.dataItem.id}`);
  };

  const EditRow = (e) => {
    return (
      <td className="">
        <button
          className="flex flex-col justify-center items-center gap-1"
          onClick={() => onEditClick(e)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
            />
          </svg>
        </button>
      </td>
    );
  };

  useEffect(() => {
    loadData();
  }, []);

  const navigate = useNavigate();

  const DateCell = (props) => {
    return (
      <td>
        {formatDate(new Date(props.dataItem[props.field]), "dd-MMM-yyyy")}
      </td>
    );
  };

  const columns = [
    {
      field: "name",
      title: t("masters.fields.name"),
      show: true,
      width: "auto",
      filterable: true,
    },
    {
      field: "startDate",
      title: t("masters.fields.startDate"),
      show: true,
      width: "auto",
      filterable: true,
      cell: DateCell,
    },
    {
      field: "endDate",
      title: t("masters.fields.endDate"),
      show: true,
      width: "auto",
      filterable: true,
      cell: DateCell,
    },
    {
      field: "Action",
      title: t("masters.fields.action"),
      show: true,
      cell: EditRow,
      width: "auto",
      filterable: true,
    },
  ];
  // const [stateColumns, setStateColumns] = React.useState(columns);
  return (
    <div className="flex flex-col dark:text-white text-black px-14 py-7 dark:bg-neutral-900 bg-white h-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="flex text-sm font-medium gap-3 items-center dark:text-white text-black">
            <button type="button" onClick={onCloseClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2.0"
                stroke="currentColor"
                className="w-7 h-7"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
                />
              </svg>
            </button>
            <label className="text-xs lg:text-lg dark:text-white text-black">
              {t("masters.headerTexts.assetScheduler")}
            </label>
          </div>
          <div className="inline-flex rounded group h-8 md:w-44 w-36 dark:border-gray-800 border-[#9D9DA1] border">
            {viewModes.map((tm) => (
              <button
                type="button"
                className={` md:text-xs text-xxs font-medium text-center transition-all ease-in-out duration-200 w-1/2 px-1 ${
                  tm.id === viewModes[0].id
                    ? "rounded-tl rounded-bl"
                    : tm.id === viewModes[viewModes.length - 1].id
                    ? "rounded-tr rounded-br border-l dark:border-gray-900 border-[#9D9DA1]"
                    : "border-l dark:border-gray-900 border-[#9D9DA1]"
                }  ${
                  !tm.current
                    ? "dark:bg-gray-900 bg-[#9D9DA1] text-white shadow-md"
                    : "text-black bg-white"
                }`}
                onClick={() =>
                  setViewModes((pre) =>
                    pre.map((x) =>
                      x.id === tm.id
                        ? { ...x, current: true }
                        : { ...x, current: false }
                    )
                  )
                }
                // disabled={disabled}
                key={tm.id}
              >
                {tm.name}
              </button>
            ))}
          </div>
          <hr className="rotate-90 w-10 h-1 border-zinc-800"></hr>
          <div>
            <form>
              <div className="relative dark:bg-gray-900 bg-[#9D9DA1] w-40 lg:w-80 h-9 rounded-lg border-zinc-800">
                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 text-neutral-700"
                    fill="none"
                    stroke={darkMode ? "white" : "black"}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    ></path>
                  </svg>
                </div>
                <input
                  type="search"
                  id="default-search"
                  name="search"
                  className="block h-full px-10 w-full  text-xs lg:text-sm font-normal bg-inherit dark:text-white text-black dark:placeholder:text-white placeholder:text-black rounded-lg"
                  placeholder={ t("masters.placeholders.schedulerSearch")}
                  onChange={onSearch}
                  required
                />
              </div>
            </form>
          </div>
        </div>
        <div className="flex dark:text-white text-black">
          <button
            type="button"
            onClick={() => navigate("/assetScheduler/new")}
            className="flex text-xs lg:text-sm font-medium h-9 px-4 dark:bg-indigo-700 bg-[#00C6C2] rounded-4xl justify-center items-center gap-2 leading-4"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            { t("button.addSchedule")}
          </button>
        </div>
      </div>
      {viewModes.find((x) => x.current).id === "grid" ? (
        <div className={`h-full my-4 w-full relative ${
          darkMode ? "darkGrid" : "lightGrid"
        }`}>
          {loading && <KendoLoadingPanel />}
          <Grid
            style={{
              height: "100%",
              width: "100%",
              backgroundColor: "#181921",
              borderRadius: "15px",
              textAlign: "justify",
              overflowY: "auto",
              scrollbarGutter: "auto",
              scrollBehavior: "smooth",
              scrollbarWidth: "auto",
            }}
            data={filteredData}
            onRowDoubleClick={onEditClick}
          >
            {columns.map(
              (column, idx) =>
                column.show && (
                  <GridColumn
                    key={idx}
                    field={column.field}
                    title={column.title}
                    filterable={column.filterable}
                    cell={column.cell}
                    width={column.width}
                    className="product-name"
                  />
                )
            )}
          </Grid>
        </div>
      ) : (
        <div className="h-[75vh] my-4">
          <Scheduler
            eventData={scheduleData}
            scheduleObj={scheduleObj}
            assets={[]}
            renderType={"scheduleList"}
            scheduleId={"list-scheduler"}
          />
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ToastContainer />
    </div>
  );
};

export default AssetScheduleList;
